<div class="pa-message-content micromate-message-content">
    <div *ngFor="let text of textMessage" [innerHTML]="text | emoji">
    </div>
</div>
